/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-26 17:34:56
 * @LastEditTime: 2022-01-26 22:15:30
 * @LastEditors: zhao - 🍉
 * @Description: 租金宝同步数据 - 订单详情
 * @FilePath: /zhzj-admin/src/page/ZJBSyncDataRecord/components/PayorderDetailListModal.jsx
 */
import { Button, Modal } from 'antd'
import React, { useState, forwardRef, useImperativeHandle } from 'react'
import ModalScrollContainer from "../../../components/ModalScrollContainer";
import TableHelper from '../../../components/TableHelper'
import { fetchZJBSyncDataPayorderInfo } from '../../../services/ZJBSyncDataRecord'
import {
    dicPayChannel,
    dicPayType,
    liuShuiMeiJu,
    mapZJBSyncDataDetailType,
    projectTransfer
} from "../../../axios/dictionaries";
import { findDict, formatTime } from '../../../utils';
import TableNewlineView from '../../../components/TableNewlineView';


const MerchantDetailListModal = (props, ref) => {
    const [visible, setVisible] = useState(false);
    const [defaultSearch, setDefaultSearch] = useState(null);
    useImperativeHandle(ref, () => ({
        open
    }))
    const open = (operationType, syncDate) => {
        setVisible(true)
        setDefaultSearch({ operationType, syncStartDate: syncDate, syncEndDate: syncDate })
    }
    const close = () => {
        setVisible(false)
        setDefaultSearch(null)
    }
    const columns = [
        { title: '租客.姓名', dataIndex: 'customerName', },
        { title: '租客.手机', dataIndex: 'customerPhone', },
        { title: '交易金额', dataIndex: 'amount', },
        { title: '优惠金额', dataIndex: 'discountAmount', },
        { title: '交易名称', dataIndex: 'feeName', },
        { title: '商户名称', dataIndex: 'merchantName', width: 200 },
        { title: '商户用户名称', dataIndex: 'merchantUserName', },
        { title: '我方流水号/他方流水号', dataIndex: 'orderNo', width: 250, render: (text, record) => {
            return <TableNewlineView>{[text, record.orderNoThird]}</TableNewlineView>
        }},
        { title: '交易方式', dataIndex: 'payType', width: 140, render: (text) => {
            return findDict(dicPayType, text).title
        } },
        { title: '交易状态', dataIndex: 'status', width: 70, render: (text) => {
            const current = findDict(projectTransfer, text)
            return <span style={{color: current.color}}>{current.title}</span>
        } },
        { title: '交易渠道', dataIndex: 'payChannel', width: 140, render: (text) => {
            return findDict(dicPayChannel, text).title
        } },
        { title: '平台商户分账金额', dataIndex: 'platformAmount', },
        { title: '项目名称', dataIndex: 'projectName', },
        { title: '房号', dataIndex: 'roomNos', },
        { title: '分账规则', dataIndex: 'subAccountDesc', },
        { title: '子商户分账金额', dataIndex: 'subAmount', },
        { title: '交易时间', dataIndex: 'tradeTime', render: formatTime}
    ]

    const searchOptions = [
        { key: 'operationType', type: 'select', options: mapZJBSyncDataDetailType },
        { key: 'syncStartDate', type: 'date', placeholder: '同步开始日期' },
        { key: 'syncEndDate', type: 'date', placeholder: '同步结束日期' },
    ]
    return (
        <Modal visible={visible} title="订单详情" width={950} destroyOnClose onCancel={close} footer={<Button onClick={close}>关闭</Button>}>
            {
                (visible && defaultSearch) && (
                    <ModalScrollContainer>
                        <TableHelper initialValue={defaultSearch} columns={columns} searchOptions={searchOptions} scroll={{ x: 2200 }} request={fetchZJBSyncDataPayorderInfo} />
                    </ModalScrollContainer>
                )
            }
        </Modal>
    )
}

export default forwardRef(MerchantDetailListModal)


// WEBPACK FOOTER //
// ./src/page/ZJBSyncDataRecord/components/PayorderDetailListModal.jsx